var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCkChevronLeftBlack = function SvgCkChevronLeftBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.273 4.94L9.33301 4L5.33301 8L9.33301 12L10.273 11.06L7.21967 8L10.273 4.94Z",
    fill: "#05141F"
  })));
};
export { SvgCkChevronLeftBlack as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjI3MyA0Ljk0TDkuMzMzMDEgNEw1LjMzMzAxIDhMOS4zMzMwMSAxMkwxMC4yNzMgMTEuMDZMNy4yMTk2NyA4TDEwLjI3MyA0Ljk0WiIgZmlsbD0iIzA1MTQxRiIvPgo8L3N2Zz4K";